import { computed, ref, watch } from "vue";
import NotificationHelper from "./NotificationHelper";
import LocSchoolMap from "../../assets/CPT-Map-LOC-School.json";
import SchoolMap from "../../assets/CPT-Map-School-LOC.json";
import APIKeyService from "../service/APIKeyService.js";
import EmailService from "../service/EmailService.js";
import LogService from "../service/LogService.js";
import MayanService from "../service/MayanService.js";
import ZipFileDataService from "../service/ZipFileDataService.js";
import moment from "moment";
import axios from "axios";
import yauzl from "yauzl";
import { fileTypeFromBuffer } from 'file-type';

const cmStatusReportsScopeFields = ["report_date", "company_name"];
const factrakScopeFields = ["job_number", "document_category", "location_id"];
const fireSafetyScopeFields = ["island", "service_contract_type"];
const hidoeDrawingsScopeFields = ["location_id", "location", "file_year", "description", "job_number", "file_type"];
const hidoeDrawingsLightScopeFields = ["location_id", "location", "file_year", "description", "job_number", "file_type"];
const mauiFireClaims2023ScopeFields = ["location_id", "action_category", "file_type", "purchase_order_originator", "delivery_party", "vendor_or_supplier", "purchase_order_number", "invoice_number"];
const warrantiesScopeFields = ["location_id", "file_year", "description", "job_number", "project_number", "work_order_number", "file_type"];

function getDataString(record) {
  let returnValue = getDataSubString(record, "label");

  let scopeFields = null;

  switch (record.scope) {
    case "CM Status Reports":
      scopeFields = cmStatusReportsScopeFields;
      break;
    case "Factrak":
      scopeFields = factrakScopeFields;
      break;
    case "Fire Safety":
      scopeFields = fireSafetyScopeFields;
      break;
    case "HIDOE Drawings":
      scopeFields = hidoeDrawingsScopeFields;
      break;
    case "HIDOE Drawings Light":
      scopeFields = hidoeDrawingsLightScopeFields;
      break;
    case "Maui Fire Claims 2023":
      scopeFields = mauiFireClaims2023ScopeFields;
      break;
    case "Warranties":
      scopeFields = warrantiesScopeFields;
      break;
  }

  if (scopeFields) {
    scopeFields.forEach((scopeField) => {
      if (record[scopeField]) {
        returnValue = `${returnValue}
${getDataSubString(record, scopeField)}`;
      }
    })
  }

  returnValue = `${returnValue}
${getDataSubString(record, "scope")}`;

  returnValue = `${returnValue}
${getDataSubString(record, "date")}`;

  return returnValue;
}

function getDataSubString(record, scopeField) {
  let headerName = "";

  switch (scopeField) {
    case "action_category":
      headerName = "Category";
      break;
    case "company_name":
      headerName = "Company Name";
      break;
    case "date":
      headerName = "Date Created";
      break;
    case "delivery_party":
      headerName = "Delivery Party";
      break;
    case "description":
      headerName = "Description";
      break;
    case "document_category":
      headerName = "Document Category";
      break;
    case "file_type":
      headerName = "Type";
      break;
    case "file_year":
      headerName = "Year";
      break;
    case "invoice_number":
      headerName = "Invoice Number";
      break;
    case "island":
      headerName = "Island";
      break;
    case "job_number":
      headerName = "Job Number";
      break;
    case "label":
      headerName = "Document Name";
      break;
    case "location":
      headerName = "Location";
      break;
    case "location_id":
      headerName = "School Name";
      break;
    case "project_number":
      headerName = "Project Number";
      break;
    case "purchase_order_number":
      headerName = "Purchase Order Number";
      break;
    case "purchase_order_originator":
      headerName = "Purchase Order Originator";
      break;
    case "report_date":
      headerName = "Report Date";
      break;
    case "scope":
      headerName = "Scope";
      break;
    case "service_contract_type":
      headerName = "Service Contract Type";
      break;
    case "vendor_or_supplier":
      headerName = "Vendor or Supplier";
      break;
    case "work_order_number":
      headerName = "Work Order Number";
      break;
  }

  return `${headerName}: ${record[scopeField]}`;
}

/*
 * Returns the fields for the selected scopes
 */
function getScopeFields(selectedSearchScopeOptions) {
  let returnValue = ["label"];

  if (selectedSearchScopeOptions.includes("HIDOE Drawings")) {
    hidoeDrawingsScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.includes("HIDOE Drawings Light")) {
    hidoeDrawingsLightScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.includes("Warranties")) {
    warrantiesScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.includes("Factrak")) {
    factrakScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.includes("Maui Fire Claims 2023")) {
    mauiFireClaims2023ScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.includes("Fire Safety")) {
    fireSafetyScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.includes("CM Status Reports")) {
    cmStatusReportsScopeFields.forEach((scopeField) => {
      if (!returnValue.includes(scopeField)) {
        returnValue.push(scopeField);
      }
    })
  }

  if (selectedSearchScopeOptions.length > 1) {
    returnValue.push("scope");
  }

  returnValue.push("date");

  return returnValue;
}

/*
 * Dictionary used when running a query search
 */
const querySearchParameters = computed(() => {
  var returnValue = {};

  const urlParams = new URLSearchParams(window.location.search);

  const querySearchParameterNames = ["action_category", "company_name", "delivery_party", "description", "document_category", "file_type", "file_year",
    "invoice_number", "island", "job_number", "jobNumber", "label", "location_id", "project_number", "purchase_order_number", "purchase_order_originator",
    "report_date", "report_date_begin", "report_date_end", "service_contract_type", "vendor_or_supplier", "work_order_number"];

  querySearchParameterNames.forEach((querySearchParameterName) => {
    var value = urlParams.get(querySearchParameterName);

    if (value) {
      if (querySearchParameterName === "jobNumber") {
        querySearchParameterName = "job_number";
      }

      if (querySearchParameterName === "report_date") {
        returnValue["report_date_begin"] = value;
        returnValue["report_date_end"] = value;
      } else if (querySearchParameterName === "location_id") {
        // Check if location_id value is a match
        if (LocSchoolMap[value] !== undefined) {
          returnValue[querySearchParameterName] = value;
        } else {
          NotificationHelper.createErrorNotification("No Location Match");
        }
      } else {
        returnValue[querySearchParameterName] = value;
      }
    }
  });

  return returnValue;
});

/*
 * Type of query search
 */
const querySearchType = computed(() => {
  let returnValue = "";

  if (Object.keys(querySearchParameters.value).length > 0) {
    returnValue = Object.keys(querySearchParameters.value).length === 1 ? "singular" : "advanced";

    if (querySearchParameters.value["report_date_begin"] !== undefined && !isValidDate(querySearchParameters.value["report_date_begin"])) {
      returnValue = `${returnValue} error`
    }

    if (!returnValue.includes("error") && querySearchParameters.value["report_date_end"] !== undefined && !isValidDate(querySearchParameters.value["report_date_end"])) {
      returnValue = `${returnValue} error`
    }

    if (!returnValue.includes("error") && querySearchParameters.value["report_date_begin"] !== undefined && querySearchParameters.value["report_date_end"] !== undefined &&
        moment(querySearchParameters.value["report_date_end"], "MM-DD-YYYY").diff(moment(querySearchParameters.value["report_date_begin"], "MM-DD-YYYY")) < 0) {
      returnValue = `${returnValue} error`
    }
  }

  return returnValue;
});

/*
 * Array and ref containing the options for the Document Category dropdown
 */
const documentCategoryOptionsArray = [
  "Allotment Request",
  "Bid Abstracts",
  "Change Orders",
  "Contract Documents",
  "Correspondence",
  "Drawings",
  "Fee Proposals",
  "Form 17",
  "JAR-SWAP Forms",
  "Meeting Minutes",
  "Payments/Monthly Estimate",
  "Project Schedule",
  "Reports",
  "Specifications"
];
const documentCategoryOptions = ref(documentCategoryOptionsArray);

/*
 * Filter function for the Document Category dropdown
 */
function filterDocumentCategory(val, update) {
  filterOptions(val, update, documentCategoryOptions, documentCategoryOptionsArray);
}

/*
 * Array and ref containing the options for the File Type dropdown
 */
const fileTypeOptionsArray = ref([]);
const fileTypeOptions = ref([]);

/*
 * Sets the value of fileTypeOptionsArray based on selectedSearchScopeOptions
 */
function setFileTypeOptions(selectedSearchScopeOptions) {
  let newValue = [];

  if (selectedSearchScopeOptions) {
    if (selectedSearchScopeOptions.includes("HIDOE Drawings")) {
      if (!newValue.includes("As-Built")) {
        newValue.push("As-Built");
      }

      if (!newValue.includes("ADD")) {
        newValue.push("ADD");
      }

      if (!newValue.includes("PCD")) {
        newValue.push("PCD");
      }
    }

    if (selectedSearchScopeOptions.includes("HIDOE Drawings Light")) {
      if (!newValue.includes("As-Built")) {
        newValue.push("As-Built");
      }

      if (!newValue.includes("ADD")) {
        newValue.push("ADD");
      }

      if (!newValue.includes("PCD")) {
        newValue.push("PCD");
      }
    }

    if (selectedSearchScopeOptions.includes("Warranties")) {
      if (!newValue.includes("JOC")) {
        newValue.push("JOC");
      }

      if (!newValue.includes("NON-JOC")) {
        newValue.push("NON-JOC");
      }
    }

    if (selectedSearchScopeOptions.includes("Maui Fire Claims 2023")) {
      if (!newValue.includes("FEMA")) {
        newValue.push("FEMA");
      }

      if (!newValue.includes("Images")) {
        newValue.push("Images");
      }

      if (!newValue.includes("Invoice")) {
        newValue.push("Invoice");
      }

      if (!newValue.includes("List-Expenses")) {
        newValue.push("List-Expenses");
      }

      if (!newValue.includes("List-Non-Expenses")) {
        newValue.push("List-Non-Expenses");
      }

      if (!newValue.includes("Map")) {
        newValue.push("Map");
      }

      if (!newValue.includes("Other")) {
        newValue.push("Other");
      }

      if (!newValue.includes("Payroll or Timesheet")) {
        newValue.push("Payroll or Timesheet");
      }

      if (!newValue.includes("P-Card")) {
        newValue.push("P-Card");
      }

      if (!newValue.includes("Purchase Order")) {
        newValue.push("Purchase Order");
      }

      if (!newValue.includes("Receipt")) {
        newValue.push("Receipt");
      }

      if (!newValue.includes("Reimbursement")) {
        newValue.push("Reimbursement");
      }

      if (!newValue.includes("Supporting Documents")) {
        newValue.push("Supporting Documents");
      }
    }
  }

  fileTypeOptionsArray.value = newValue;
  fileTypeOptions.value = newValue;
}

/*
 * Filter function for the File Type dropdown
 */
function filterFileType(val, update) {
  filterOptions(val, update, fileTypeOptions, fileTypeOptionsArray.value);
}

/*
 * Array and ref containing the options for the School dropdown
 */
const schoolOptionsArray = Object.keys(SchoolMap);
const schoolOptions = ref(schoolOptionsArray);

/*
 * Filter function for the School dropdown
 */
function filterSchool(val, update) {
  filterOptions(val, update, schoolOptions, schoolOptionsArray);
}

/*
 * Array and ref containing the options for the Action Category dropdown
 */
const actionCategoryOptionsArray = [
  "Cleaning",
  "Furniture and Equipment",
  "Materials and Supplies",
  "Other",
  "Permanent Replacement Facilities",
  "Repairs",
  "Security Services",
  "Signed",
  "Technology",
  "Temporary Facilities",
  "Temporary Facilities Services",
  "Transportation-Goods",
  "Transportation-Students",
  "Travel"
];
const actionCategoryOptions = ref(actionCategoryOptionsArray);

/*
 * Filter function for the Action Category dropdown
 */
function filterActionCategory(val, update) {
  filterOptions(val, update, actionCategoryOptions, actionCategoryOptionsArray);
}

/*
 * Array and ref containing the options for the Island dropdown
 */
const islandOptionsArray = [
  "Hawaii",
  "Kauai, Niihau",
  "Maui, Molokai, Lanai",
  "Oahu"
];
const islandOptions = ref(islandOptionsArray);

/*
 * Filter function for the Island dropdown
 */
function filterIsland(val, update) {
  filterOptions(val, update, islandOptions, islandOptionsArray);
}

/*
 * Array and ref containing the options for the Service Contract Type dropdown
 */
const serviceContractTypeOptionsArray = [
  "Fire Alarm",
  "Fire Hydrant",
  "Fire Suppression"
];
const serviceContractTypeOptions = ref(serviceContractTypeOptionsArray);

/*
 * Filter function for the Service Contract Type dropdown
 */
function filterServiceContractType(val, update) {
  filterOptions(val, update, serviceContractTypeOptions, serviceContractTypeOptionsArray);
}

/*
 * Array and ref containing the options for the Company Name dropdown
 */
const companyNameOptionsArray = [ "Company AAA", "Company BBB", "Company CCC", "Company DDD", "Company EEE", "Company FFF" ];
const companyNameOptions = ref(companyNameOptionsArray);

/*
 * Filter function for the Company Name dropdown
 */
function filterCompanyName(val, update) {
  filterOptions(val, update, companyNameOptions, companyNameOptionsArray);
}

/*
 * Common filter function
 */
function filterOptions(val, update, options, optionsArray) {
  update(
    () => {
      const needle = val.toLowerCase();

      options.value = optionsArray.filter(
        (v) => v.toLowerCase().includes(needle)
      );
    },
    ref => {
      ref.setOptionIndex(-1) // reset optionIndex in case there is something selected
      ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
    }
  );

  options.value.sort();
}

/*
 * Common filter function for object options
 */
function filterObjectOptions(val, update, options, optionsArray) {
  update(
    () => {
      const needle = val.toLowerCase();

      options.value = optionsArray.filter(
        (v) => v.label.toLowerCase().indexOf(needle) > -1
      );
    },
    ref => {
      ref.setOptionIndex(-1) // reset optionIndex in case there is something selected
      ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
    }
  );

  options.value.sort((a, b) => {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  })
}

const indexCounts = ref(null);
const loadingQuerySearch = ref(true);
const tableInput = ref([]);
const searchCompleted = ref([]);
const searchCompletedByScope = ref({});
const indexSearchCompletedByScope = ref({});
const indexSearchSafetyCount = ref({});
const searchCanceled = ref(false);
const searchError = ref(false);

async function getIndexCounts() {
  try {
    const response = await axios.get(`${process.env.VUE_APP_API_GATEWAY}getIndexCounts?key=${process.env.VUE_APP_API_KEY}`);

    indexCounts.value = response.data;
  } catch (error) {
    EmailService.sendErrorEmail("CommonHelper.js - getIndexCounts", error);
    indexCounts.value = {};
  }
}

function isIndexCountMet(scope) {
  let returnValue = false;

  if (indexCounts.value && indexCounts.value[scope] && tableInput.value) {
    const scopeTableInput = tableInput.value.filter((val) => {
      return val.scope === scope;
    });

    returnValue = scopeTableInput.length >= indexCounts.value[scope];
  }

  return returnValue;
}

const currentUserData = ref(null);
const currentUserGroup = ref(null);

/*
 * Set currentUserData ref and currentUserGroup ref
 */
async function setCurrentUserData(newCurrentUserData) {
  currentUserData.value = newCurrentUserData;
  
  if (currentUserData.value) {
    const userGroups = await getUserGroups(false);
    let currentUserGroupArray = [];
    userGroups.forEach((userGroup) => {
      if (userGroup.emails && userGroup.emails.includes(currentUserData.value.email)) {
        currentUserGroupArray.push(userGroup);
      }
    });
    currentUserGroup.value = currentUserGroupArray;
  }
}

const userGroupsArray = ref([]);

async function getUserGroups(overwrite) {
  try {
    if (overwrite || userGroupsArray.value.length === 0) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_GATEWAY}getUserGroups?key=${process.env.VUE_APP_API_KEY}`
      );
      
      if (response && response.data) {
        userGroupsArray.value = response.data;
      } else {
        userGroupsArray.value = [];
      }
    }

    return userGroupsArray.value;  
  } catch (error) {
    EmailService.sendErrorEmail("CommonHelper.js - getUserGroups", error);
    NotificationHelper.createErrorNotification("Error encountered. Please try again.");
  }
}

const rowData = computed(() => {
  let myTarget = JSON.parse(JSON.stringify(tableInput.value));
  var rowObj = [];

  myTarget.forEach((i) => {
    if (selectedSearchScopeOptions.value.includes(i.scope) && displayRecord(i)) {
      rowObj.push(i);
    }
  });

  return rowObj;
});

function addFileInfoDocumentName(record) {
  record.file_info = [
    record.id,
    record.label,
    record.scope,
    record.folder_structure,
    getDataString(record)
  ];

  record.document_name = [
    record.id,
    record.label,
    record.file_count
  ];
}

function getSchoolNameArray(locationIdString) {
  let returnValue = [];

  if (locationIdString) {
    const locationIdList = Object.keys(LocSchoolMap);
    locationIdString.split(":::").forEach((locationId) => {
      if (locationIdList.includes(locationId)) {
        returnValue.push(LocSchoolMap[locationId]);
      }
    });
    returnValue.sort();
  }

  return returnValue;
}

const firestoreTableInput = ref({});

watch([firestoreTableInput, indexCounts], () => {
  if (firestoreTableInput.value === null && indexCounts.value !== null && searchSubmitted.value && !displayCancelBtn.value) {
    submitSearch(queryArray.value);
  }
});

const firestoreIndexRecordsRetrieved = ref({});

const firestoreIndexRecordsRunning = computed(() => {
  return Object.values(firestoreIndexRecordsRetrieved.value).includes(false);
});

watch(firestoreIndexRecordsRunning, () => {
  if (!firestoreIndexRecordsRunning.value && firestoreTableInput.value) {
    let newTableInput = [];

    Object.values(firestoreTableInput.value).forEach((table) => {
      newTableInput = newTableInput.concat(table);
    })

    if (newTableInput.length > 0) {
      if (tableInput.value.length > 0) {
        // Updates the record; Occurs when it is the document_id query parameter search 
        tableInput.value.forEach((tableInputElement) => {
          const elementIndex = newTableInput.findIndex((element) => {
            return element.id === tableInputElement.id;
          });

          if (elementIndex >= 0) {
            newTableInput[elementIndex] = tableInputElement;
          } else {
            newTableInput.push(tableInputElement);
          }
        });
      }

      tableInput.value = getUniqueArrayOfObjects(newTableInput);
    }

    checkDocumentUpdate();

    firestoreTableInput.value = null;
  }
});

/*
 * Inputs an array of objects and returns an unique array of objects
 */
function getUniqueArrayOfObjects(array) {
  let returnValue = array;
  if (array.length > 0) {
    const jsonObject = array.map(JSON.stringify);
    const uniqueSet = new Set(jsonObject);
    returnValue = Array.from(uniqueSet).map(JSON.parse);
  }
  return returnValue;
}

async function retrieveFirestoreIndex(searchScopeOptionsArray) {
  searchScopeOptionsArray.forEach((scope) => {
    retrieveFirestoreIndexRecords(scope);
  })
}

async function retrieveFirestoreIndexRecords(scope) {
  try {
    firestoreIndexRecordsRetrieved.value[scope] = false;

    const response = await axios.get(`${process.env.VUE_APP_API_GATEWAY}getIndexRecords?key=${process.env.VUE_APP_API_KEY}&searchScope=${scope.replaceAll(" ", "_")}`);

    if (firestoreTableInput.value) {
      firestoreTableInput.value[scope] = response.data;
    }

    firestoreIndexRecordsRetrieved.value[scope] = true;
  } catch (error) {
    const errorMessage = `scope: ${scope}

${error}`;

    EmailService.sendErrorEmail("CommonHelper.js - retrieveFirestoreIndexRecords", errorMessage);
    firestoreTableInput.value = null;
  }
}

function setSearchCompleted(index, value) {
  searchCompleted.value[index] = value;
}

function setSearchCompletedByScope(key, value) {
  searchCompletedByScope.value[key] = value;
}

function isSearchCompletedByScope(key) {
  // true is the default since the search will continue while the value is false
  return searchCompletedByScope.value[key] !== undefined ? searchCompletedByScope.value[key] : true;
}

function interruptIndexSearch() {
  Object.keys(indexSearchCompletedByScope.value).forEach((key) => {
    if (indexSearchCompletedByScope.value[key] !== "complete") {
      indexSearchCompletedByScope.value[key] = "interrupted";
    }
  });
}

function cancelSearch() {
  searchCompleted.value = [];
  searchCompletedByScope.value = {};
  interruptIndexSearch();
  searchCanceled.value = true;
}

const displayCancelBtn = computed(() => {
  let returnVal = false;

  if (Object.keys(searchCompletedByScope.value).length > 0) {
    returnVal = Object.keys(searchCompletedByScope.value).some(key => !searchCompletedByScope.value[key]);
  }

  if (!returnVal && Object.keys(indexSearchCompletedByScope.value).length > 0) {
    returnVal = Object.keys(indexSearchCompletedByScope.value).some(key => indexSearchCompletedByScope.value[key] === "running");
  }

  return returnVal;
});

const loadingInitialSearchResults = computed(() => {
  return searchCompleted.value.includes(false) || (displayCancelBtn.value && rowData.value.length === 0);
});

const searchDocumentId = ref();

/*
 * Displays the metadata for a single document
 */
function displayMetadata(documentId, scope) {
  searchDocumentId.value = documentId;
  queryArray.value = undefined;

  if (!selectedSearchScopeOptions.value.includes(scope)) {
    addSelectedSearchScopeOption(scope);
  }
}

/*
 * Calls "documentIdSearchTableInput" if "document_id" has been provided, sets loadingQuerySearch to false
 */
async function checkLoadingQuerySearch() {
  if (querySearchType.value === "" || querySearchType.value.includes("error")) {
    const urlParams = new URLSearchParams(window.location.search);
    searchDocumentId.value = urlParams.get("document_id");

    if (searchDocumentId.value) {
      documentIdSearchTableInput(searchDocumentId.value);
    } else {
      loadingQuerySearch.value = false;
    }
  }
}

const documentIdSearchIds = ref([]);

/*
 * Insert/update an item in tableInput after calling "MayanService.documentIdSearch"
 */
async function documentIdSearchTableInput(documentId) {
  if (!documentIdSearchIds.value.includes(documentId)) {
    documentIdSearchIds.value.push(documentId);

    await MayanService.documentIdSearch(documentId)
      .then((response) => {
        if (response.data) {
          insertUpdateTableInput(response.data);
        }

        if (searchDocumentId.value) {
          loadingQuerySearch.value = false;
        }
      })
      .catch((error) => {
        const errorMessage = `documentId: ${documentId}

${error}`;

        EmailService.sendErrorEmail("CommonHelper.js - documentIdSearchTableInput", errorMessage);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      });
  }
}

const queryArray = ref();

const searchSubmitted = computed(() => {
  return queryArray.value !== undefined;
});

const selectedSearchScopeOptions = ref([]);

/*
 * Filter function for the Scopes dropdown
 */
function addSelectedSearchScopeOption(scope) {
  selectedSearchScopeOptions.value.push(scope);
}

const selectedSearchScopeOptionsLength = computed(() => {
  return selectedSearchScopeOptions.value.length;
});

function submitSearch(newQueryArray) {
  queryArray.value = newQueryArray;

  if (firestoreTableInput.value === null && indexCounts.value !== null) {
    const processedQueryArray = getProcessedQueryArray();

    if (processedQueryArray !== null) {
      const query = getQueryString(processedQueryArray);

      searchCompletedByScope.value = {};
      interruptIndexSearch();
      searchCanceled.value = false;
      searchError.value = false;

      checkDocumentUpdate();

      // mayanServiceIndexSearch
      const pageSize = 50;

      selectedSearchScopeOptions.value.forEach((scope) => {
        submitMayanServiceIndexSearch(scope, pageSize);
      })

      // mayanServiceAdvancedSearch
      selectedSearchScopeOptions.value.forEach((scope, index) => {
        const scopeQuery = query.replaceAll(`_document_type__label=scope`, `_document_type__label=%22${scope.replaceAll(" ", "_")}%22`);
        mayanServiceAdvancedSearch(scopeQuery, scope, index, 1);
      })

      // mayanServiceSingularSearch
      if (processedQueryArray.length > 1) {
        processedQueryArray.forEach((query) => {
          selectedSearchScopeOptions.value.forEach((scope) => {
            mayanServiceSingularSearch(query.searchAttribute.value, query.searchText, scope, 1);
          })
        })
      }

      loadingQuerySearch.value = false;
    }
  } else {
    // show loading overlay
    setSearchCompleted(0, false);
  }
}

/*
 * Returns the processed query array (query array with values added or removed as appropriate)
 */
function getProcessedQueryArray() {
  let returnValue = [];

  let reportDateBegin = null;
  let reportDateEnd = null;

  queryArray.value.forEach((query) => {
    let searchAttribute = query.searchAttribute;
    let searchText = query.searchText;

    if (searchAttribute && searchText) {
      if (searchAttribute.value === "location_id" && returnValue !== null) {
        let schoolRecord = SchoolMap[searchText];

        returnValue.push(
          {
            searchText: schoolRecord.location_id,
            searchAttribute: { value: "location_id" }
          }  
        );

        if (schoolRecord.alternate_location_id !== undefined) {
          let alternateLocationIdArray = schoolRecord.alternate_location_id.split(",");

          alternateLocationIdArray.forEach((alternateLocationId) => {
            returnValue.push(
              {
                searchText: alternateLocationId,
                searchAttribute: { value: "location_id" }
              }
            );
          })
        }
      } else if (searchAttribute.value === "report_date_begin" && returnValue !== null) {
        if (isValidDate(searchText)) {
          reportDateBegin = moment(searchText, "MM-DD-YYYY");
        } else {
          NotificationHelper.createErrorNotification("Report Date Begin is an invalid date");
          returnValue = null;
        }
      } else if (searchAttribute.value === "report_date_end" && returnValue !== null) {
        if (isValidDate(searchText)) {
          reportDateEnd = moment(searchText, "MM-DD-YYYY");
        } else {
          NotificationHelper.createErrorNotification("Report Date End is an invalid date");
          returnValue = null;
        }
      } else if (returnValue !== null) {
        if (query.searchText.indexOf(" ") >= 0) {
          let queryArray = query.searchText.split(" ");

          queryArray.filter((val) => {
            return val;
          }).forEach((val) => {
            returnValue.push(
              {
                searchText: val,
                searchAttribute: { value: query.searchAttribute.value }
              }
            );
          })
        } else {
          returnValue.push(query);
        }
      }
    }
  })

  if (reportDateBegin !== null || reportDateEnd !== null) {
    if (reportDateBegin === null) {
      // set to 10 years before reportDateEnd
      reportDateBegin = moment(reportDateEnd).add(-50, "years");
    } else if (reportDateEnd === null) {
      // set to 10 years after reportDateBegin
      reportDateEnd = moment(reportDateBegin).add(50, "years");
    }

    if (reportDateEnd.diff(reportDateBegin) < 0) {
      NotificationHelper.createErrorNotification("Report Date Begin cannot be later than Report Date End");
      returnValue = null;
    } else if (returnValue !== null) {
      const dateRangeArray = getDateRangeArray(reportDateBegin, reportDateEnd);

      dateRangeArray.forEach((date) => {
        returnValue.push(
          {
            searchText: date,
            searchAttribute: { value: "report_date" }
          }
        );
      })
    }
  }

  return returnValue;
}

/*
 * Returns the date range array based on report_date_begin and report_date_end
 */
function getDateRangeArray(reportDateBegin, reportDateEnd) {
  let returnValue = [];

  if (reportDateEnd.diff(reportDateBegin, "years") > 6) {
    // add by decades
    let date = moment(reportDateBegin);

    while (date.format("YYYY_").substring(0, 3) !== reportDateEnd.format("YYYY_").substring(0, 3)) {
      returnValue.push(date.format("YYYY_").substring(0, 3));
      date = date.add(10, "years");
    }

    returnValue.push(reportDateEnd.format("YYYY_").substring(0, 3));
  } else if (reportDateEnd.diff(reportDateBegin, "months") > 6) {
    // add by years
    let date = moment(reportDateBegin);

    while (date.format("YYYY_") !== reportDateEnd.format("YYYY_")) {
      returnValue.push(date.format("YYYY_"));
      date = date.add(1, "years");
    }

    returnValue.push(reportDateEnd.format("YYYY_"));
  } else {
    // add by months
    let date = moment(reportDateBegin);

    while (date.format("YYYY_MM_") !== reportDateEnd.format("YYYY_MM_")) {
      returnValue.push(date.format("YYYY_MM_"));
      date = date.add(1, "months");
    }

    returnValue.push(reportDateEnd.format("YYYY_MM_"));
  }

  return returnValue;
}

const queryIndex = ref(1);

/*
 * Returns the query string based on processedQueryArray and scope
 */
function getQueryString(processedQueryArray) {
  let returnValue = "__0_document_type__label=scope";

  if (processedQueryArray.length > 0) {
    queryIndex.value = 1;

    processedQueryArray.forEach((query) => {
      let searchAttribute = query.searchAttribute;
      let searchText = query.searchText;

      returnValue += getQuerySubstring(searchAttribute, searchText);
    })

    returnValue += `&__${queryIndex.value}=AND`;

    for (let i = 0; i < queryIndex.value; i++) {
      returnValue += `_${i}`;
    }

    returnValue += `&__result=${queryIndex.value}`;
  } else {
    // default query string that doesn't search for specific text
    returnValue += "&__result=0";
  }

  return returnValue;
}

/*
 * Returns a substring of the query from the given parameters
 */
function getQuerySubstring(searchAttribute, searchText) {
  if (searchText.indexOf(" ") >= 0) {
    searchText = `%22${searchText}%22`;
  }

  if (searchAttribute.value === "label") {
    queryIndex.value += 1;

    return `&__${queryIndex.value - 1}_label=${searchText}`;
  } else {
    queryIndex.value += 2;

    return `&__${queryIndex.value - 2}_metadata__metadata_type__name=${searchAttribute.value}&__${queryIndex.value - 1}_metadata__value=${searchText}`;
  }
}

const documentUpdateDate = ref(null);

/*
 * Calls "LogService.getDocumentUpdate" in order to update tableInput.
 */
async function checkDocumentUpdate() {
  const response = await LogService.getDocumentUpdate();

  const seenDocumentIds = [];

  response.data.forEach((documentUpdate) => {
    let isNew = false;

    if (documentUpdateDate.value === null) {
      isNew = true;
    } else if (moment(documentUpdate.date).toDate() >= documentUpdateDate.value) {
      isNew = true;
    }

    if (isNew) {
      if (documentUpdate.type === "Delete") {
        deleteFromTableInput(documentUpdate.document_id);
      } else if (!searchCanceled.value && !seenDocumentIds.includes(documentUpdate.document_id)) {
        seenDocumentIds.push(documentUpdate.document_id);
        documentIdSearchTableInput(documentUpdate.document_id);
      }
    }
  })

  documentUpdateDate.value = moment().toDate();
}

/*
 * Calls "mayanServiceIndexSearch" using various page numbers.
 * All pages will be loaded in the background.
 */
async function submitMayanServiceIndexSearch(scope, pageSize) {
  if (!isIndexCountMet(scope)) {
    mayanServiceIndexSearch(scope, 1, pageSize, `${scope}_1_${pageSize}`);
    mayanServiceIndexSearch(scope, 2, pageSize, `${scope}_2_${pageSize}`);
    mayanServiceIndexSearch(scope, 3, pageSize, `${scope}_3_${pageSize}`);
    mayanServiceIndexSearch(scope, 4, pageSize, `${scope}_4_${pageSize}`);
    mayanServiceIndexSearch(scope, 5, pageSize, `${scope}_5_${pageSize}`);
  }
}

/*
 * Calls "MayanService.indexSearch" as often as necessary to retrieve all of the results.
 * All pages will be loaded in the background.
 */
async function mayanServiceIndexSearch(scope, pageNumber, pageSize, key) {
  if (indexSearchCompletedByScope.value[key] !== "complete") {
    if (pageNumber <= 5) {
      indexSearchCompletedByScope.value[key] = "running";
    }

    MayanService.indexSearch(scope.replaceAll(" ", "_"), pageNumber)
      .then((response) => {
        if (indexSearchCompletedByScope.value[key] === "running" && !isIndexCountMet(scope)) {
          processAPIResponse(response.data);
        }

        if (response.data.length < pageSize || isIndexCountMet(scope)) {
          indexSearchCompletedByScope.value[key] = "complete";
        }

        if (indexSearchCompletedByScope.value[key] === "running") {
          mayanServiceIndexSearch(scope, pageNumber + 5, pageSize, key);
        }
      })
      .catch((error) => {
        const errorMessage = `scope: ${scope}
pageNumber: ${pageNumber}
pageSize: ${pageSize}

${error}`;

        EmailService.sendErrorEmail("CommonHelper.js - mayanServiceIndexSearch", errorMessage);

        const safetyCount = indexSearchSafetyCount.value[key] ? indexSearchSafetyCount.value[key] : 0;

        if (safetyCount < 10) {
          if (indexSearchCompletedByScope.value[key] === "running") {
            indexSearchSafetyCount.value[key] = safetyCount + 1;
            mayanServiceIndexSearch(scope, pageNumber, pageSize, key);
          }
        } else {
          indexSearchCompletedByScope.value[key] = "interrupted";
        }
      });
  }
}

/*
 * Calls "MayanService.advancedSearch" as often as necessary to retrieve all of the results.
 * Certain actions will only occur when pageNumber === 1 as only the first page will affect the loading
 * indicator, error message, etc.  All other pages will be loaded in the background.
 */
async function mayanServiceAdvancedSearch(query, scope, index, pageNumber) {
  const key = query + "_" + scope;

  if (pageNumber === 1) {
    setSearchCompleted(index, rowData.value.length > 0);
    setSearchCompletedByScope(key, false);
  }

  MayanService.advancedSearch(query, pageNumber)
    .then((response) => {
      if (!isSearchCompletedByScope(key) && !isIndexCountMet(scope)) {
        processAPIResponse(response.data);
      }

      if (pageNumber === 1) {
        setSearchCompleted(index, true);
      }

      if (response.data.length < 50 || isIndexCountMet(scope)) {
        setSearchCompletedByScope(key, true);
      }

      if (!isSearchCompletedByScope(key)) {
        mayanServiceAdvancedSearch(query, scope, index, pageNumber + 1);
      }
    })
    .catch((error) => {
      const errorMessage = `query: ${query}
scope: ${scope}
pageNumber: ${pageNumber}

${error}`;

      EmailService.sendErrorEmail("CommonHelper.js - mayanServiceAdvancedSearch", errorMessage);

      if (pageNumber === 1) {
        setSearchCompleted(index, true);
        searchError.value = true;
      }

      setSearchCompletedByScope(key, true);
    });
}

/*
 * Calls "mayanServiceSingularSearch" by splitting metadataValue.
 * All pages will be loaded in the background.
 */
async function submitMayanServiceSingularSearch(metadataName, metadataValue, scope) {
  mayanServiceSingularSearch(metadataName, metadataValue, scope, 1);

  if (metadataValue.includes("/") || metadataValue.includes(" ")) {
    metadataValue.split("/").filter((val1) => {
      return val1;
    }).forEach((val1) => {
      val1.split(" ").filter((val2) => {
        return val2;
      }).forEach((val2) => {
        mayanServiceSingularSearch(metadataName, val2, scope, 1);
      })
    })
  }
}

/*
 * Calls "MayanService.singularSearch" as often as necessary to retrieve all of the results.
 * All pages will be loaded in the background.
 */
async function mayanServiceSingularSearch(metadataName, metadataValue, scope, pageNumber) {
  const key = metadataName + "_" + metadataValue + "_" + scope;

  if (pageNumber === 1) {
    setSearchCompletedByScope(key, false);
  }

  MayanService.singularSearch(metadataName, metadataValue, scope.replaceAll(" ", "_"), pageNumber)
    .then((response) => {
      if (!isSearchCompletedByScope(key) && !isIndexCountMet(scope)) {
        processAPIResponse(response.data);
      }

      if (response.data.length < 50 || isIndexCountMet(scope)) {
        setSearchCompletedByScope(key, true);
      }

      if (!isSearchCompletedByScope(key)) {
        mayanServiceSingularSearch(metadataName, metadataValue, scope, pageNumber + 1);
      }
    })
    .catch((error) => {
      const errorMessage = `metadataName: ${metadataName}
metadataValue: ${metadataValue}
scope: ${scope}
pageNumber: ${pageNumber}

${error}`;

      EmailService.sendErrorEmail("CommonHelper.js - mayanServiceSingularSearch", errorMessage);
      setSearchCompletedByScope(key, true);
    });
}

async function processAPIResponse(records) {
  if (records) {
    records.forEach(async (record) => {
      if (record) {
        insertUpdateTableInput(record);
      }
    });
  }
}

/*
 * Insert/update a record in tableInput
 */
function insertUpdateTableInput(record) {
  const tableInputIndex = tableInput.value.findIndex((i) => {
    return i.id === record.id;
  });

  if (tableInputIndex >= 0) {
    if (!isEqual(tableInput.value[tableInputIndex], record)) {
      tableInput.value[tableInputIndex] = record;
    }
  } else {
    tableInput.value.push(record);

    // Temporarily disabled: addToDocumentUpdate was flooding the document_update collection
    // with "Search" type records (one per new record per user session), which caused
    // checkDocumentUpdate to make 10,000+ API calls on page load. Since getDocumentUpdate
    // now filters out "Search" type records, these writes have no effect.
    // if (!documentIdSearchIds.value.includes(record.id)) {
    //   addToDocumentUpdate(record.id);
    // }
  }
}

function isEqual(record1, record2) {
  const keys1 = Object.keys(record1);
  const keys2 = Object.keys(record2);

  let returnValue = keys1.length === keys2.length;

  if (returnValue) {
    keys1.forEach((key) => {
      if (key !== "file_info" && key !== "document_name") {
        if (returnValue && record1[key] !== record2[key]) {
          returnValue = false;
        }
      }
    });
  }

  return returnValue;
}

async function addToDocumentUpdate(document_id) {
  try {
    const url = `${process.env.VUE_APP_API_GATEWAY}addToDocumentUpdate?document_id=${document_id}&key=${process.env.VUE_APP_API_KEY}`;

    axios.post(url);
  } catch (error) {
    const errorMessage = `document_id: ${document_id}

${error}`;

    EmailService.sendErrorEmail("CommonHelper.js - addToDocumentUpdate", errorMessage);
  }
}

/*
 * Determines whether or not a record should be diplayed in the results table
 */
function displayRecord(record) {
  var returnValue = searchSubmitted.value || searchDocumentId.value == record.id;

  if (returnValue && !currentUserData.value.accessLevel.includes("Admin") && record.access_user_group_uid) {
    let userGroupReturnValue = false;
    const recordAccessUserGroupUidArray = record.access_user_group_uid.split(":::");
    currentUserGroup.value.forEach((userGroup) => {
      recordAccessUserGroupUidArray.forEach((recordUserGroup) => {
        if (recordUserGroup === userGroup.uid) {
          userGroupReturnValue = true;
        }
      });
    });

    returnValue = userGroupReturnValue;
  }

  if (queryArray.value && returnValue) {
    queryArray.value.forEach((i) => {
      var searchAttribute = i.searchAttribute;
      var searchText = i.searchText;
  
      if (searchAttribute && searchText) {
        switch (searchAttribute.value) {
          case "action_category":
            if (!record.action_category_original || !record.action_category_original.toLowerCase().split(":::").includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "company_name":
            if (!record.company_name || !record.company_name.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "delivery_party":
            if (!record.delivery_party || !record.delivery_party.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "description":
            if (!record.description || !record.description.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "document_category":
            if (!record.document_category || !record.document_category.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "file_type":
            if (!record.file_type || !record.file_type.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            } else if (searchText.toLowerCase() === "joc" && record.file_type.toLowerCase() !== "joc") {
              returnValue = false;
            }
            break;
          case "file_year":
            if (!record.file_year || !record.file_year.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "invoice_number":
            if (!record.invoice_number || !record.invoice_number.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "island":
            if (!record.island_original || !record.island_original.toLowerCase().split(":::").includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "job_number":
            if (!record.job_number || !record.job_number.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "label":
            if (!record.label || !record.label.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "location_id":
            const schoolNameArray = getSchoolNameArray(record.location_id_original);
            if (!record.location_id_original || !schoolNameArray.includes(searchText)) {
              returnValue = false;
            }
            break;
          case "project_number":
            if (!record.project_number || !record.project_number.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "purchase_order_number":
            if (!record.purchase_order_number || !record.purchase_order_number.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "purchase_order_originator":
            if (!record.purchase_order_originator || !record.purchase_order_originator.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "report_date_begin":
            const dateArray1 = record.report_date_original.split(",");
            if (!record.report_date_original || !checkValidDateArray(dateArray1, "YYYY_MM_DD")) {
              returnValue = false;
            } else {
              let reportDateArray = dateArray1.map((date) => moment(date, "YYYY_MM_DD"));
              let searchDate = moment(searchText, "MM-DD-YYYY");
  
              let matchingDateFound = false;
              reportDateArray.forEach((date) => {
                if (searchDate.diff(date) <= 0) {
                  matchingDateFound = true;
                }
              });
              
              if (!matchingDateFound) {
                returnValue = false;
              }
            }
            break;
          case "report_date_end":
            const dateArray2 = record.report_date_original.split(",");
            if (!record.report_date_original || !checkValidDateArray(dateArray2, "YYYY_MM_DD")) {
              returnValue = false;
            } else {
              let reportDateArray = dateArray2.map((date) => moment(date, "YYYY_MM_DD"));
              let searchDate = moment(searchText, "MM-DD-YYYY");

              let matchingDateFound = false;
              reportDateArray.forEach((date) => {
                if (date.diff(searchDate) <= 0) {
                  matchingDateFound = true;
                }
              });
              
              if (!matchingDateFound) {
                returnValue = false;
              }
            }
            break;
          case "service_contract_type":
            if (!record.service_contract_type || !record.service_contract_type.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "vendor_or_supplier":
            if (!record.vendor_or_supplier || !record.vendor_or_supplier.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
          case "work_order_number":
            if (!record.work_order_number || !record.work_order_number.toLowerCase().includes(searchText.toLowerCase())) {
              returnValue = false;
            }
            break;
        }
      }
    });
  }

  return returnValue;
}

/*
 * Deletes an item from tableInput based on documentId
 */
function deleteFromTableInput(documentId) {
  let recordIndex = -1;

  tableInput.value.forEach((i, index) => {
    if (i.id === documentId) {
      recordIndex = index;
    }
  });

  if (recordIndex !== -1) {
    tableInput.value.splice(recordIndex, 1);
  }
}

/*
 * Returns the filename to use in the fastify functions
 */
async function getFastifyFilename(originalFilename) {
  let fastifyFilename = originalFilename.replace(/[^a-zA-Z0-9.:]/g, ':');

  const uid = await APIKeyService.generateUniqueIdentifier(fastifyFilename);

  fastifyFilename = `${uid}:::${fastifyFilename}`;

  return fastifyFilename;
}

async function createEmptyDocument(label, document_type_id) {
  const response = await axios.get(
    `${process.env.VUE_APP_API_GATEWAY}createEmptyDocument?key=${process.env.VUE_APP_API_KEY}&label=${encodeURIComponent(label)}&document_type_id=${document_type_id}`
  );

  return response.data.data;
}

/*
 * Returns the color for the header button
 */
function getHeaderButtonColor(active, darkMode) {
  let returnValue = darkMode ? "#B3D9FF" : "#0067C1";

  if (!active) {
    if (darkMode) {
      returnValue = "#CFCFCF";
    } else {
      returnValue = "#4A4A4A";
    }
  }

  return returnValue;
}

/*
 * Returns whether or not date is valid
 */
function isValidDate(date) {
  return moment(date, "MM-DD-YYYY", true).isValid();
}

/*
 * Returns whether or not date array is valid
 */
function checkValidDateArray(array, dateFormat) {
  let returnValue = true;
  array.forEach((date) => {
    if (!moment(date, dateFormat, true).isValid()) {
      returnValue = false;
    }
  });
  return returnValue;
}

/*
 * Returns a sorted array of objects by 'label' key
 */
function sortArrayOfObjects(array) {
  if (array.length > 1) {
    array.sort((a, b) => {
      return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    })
  }
  return array;
}

const nonDeleteList = ["Factrak"];
const nonEditList = ["Factrak"];
const nonUploadList = ["Factrak"];

/*
 * Checks the current scope if edit is possible. Can add additional non-edit scopes to nonEditList.
 * Returns false if current scope is a non-edit scope; otherwise, returns true
 */
function checkScopeEdit(currentScope) {
  return !nonEditList.includes(currentScope);
}

/*
 * Checks the current scope if upload is possible. Can add additional non-upload scopes to nonUploadList.
 * Returns false if current scope is a non-upload scope; otherwise, returns true
 */
function checkScopeUpload(currentScope) {
  return !nonUploadList.includes(currentScope);
}

function openURLToNewTab(url) {
  window.open(url,'_blank');
}

function replaceHTMLReservedCharacters(text) {
  let returnValue = text;

  try {
    returnValue = decodeURIComponent(returnValue);
  } catch {
    // text cannot be decoded because it has not been encoded
  }

  const htmlMap = {
    "&#34;": '"',
    "&quot;": '"',
    "&#38;": "&",
    "&amp;": "&",
    "&#x27;": "'",
    "&#39;": "'",
    "&apos;": "'",
    "&#60;": "<",
    "&lt;": "<",
    "&#62;": ">",
    "&gt;": ">"
  };
  const regexStr = Object.keys(htmlMap).map((val) => { return `(${val})`; }).join("|");
  const regex = new RegExp(regexStr, "g");

  returnValue = returnValue.replace(regex, function(val) { return htmlMap[val] });

  return returnValue;
}

const storedFileLatest = ref({});
const fileVersionDataDocumentId = ref(null);

async function updateStoredFileLatest(documentId, setFileVersionDataDocumentId) {
  try {
    const fileLatest = await MayanService.fileLatest(documentId);

    storedFileLatest.value[documentId] = fileLatest.data.data.results;

    if (storedFileLatest.value[documentId] && storedFileLatest.value[documentId].length > 1) {
      await documentIdSearchTableInput(documentId);

      storedFileLatest.value[documentId] = storedFileLatest.value[documentId].sort((a, b) => {
        // sort by latest first
        const dateA = moment(a.timestamp).toDate();
        const dateB = moment(b.timestamp).toDate();

        return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
      })

      if (setFileVersionDataDocumentId) {
        fileVersionDataDocumentId.value = documentId;
      }

      const record = tableInput.value.find((i) => {
        if (i.id === documentId) {
          return i;
        }
      });

      if (record) {
        const file_version_data_json = record.file_version_data ? JSON.parse(record.file_version_data) : {};

        const deletedFileId = file_version_data_json.deletedFileId ? file_version_data_json.deletedFileId : [];

        storedFileLatest.value[documentId] = storedFileLatest.value[documentId].filter((file) => {
          return !deletedFileId.includes(file.id);
        })
      }
    } else if (setFileVersionDataDocumentId) {
      fileVersionDataDocumentId.value = null;
    }
  } catch (error) {
    const errorMessage = `documentId: ${documentId}

${error}`;

    EmailService.sendErrorEmail("CommonHelper.js - updateStoredFileLatest", errorMessage);
    // do nothing
  }
}

const currentFileVersionData = computed(() => {
  let returnValue = {};

  if (fileVersionDataDocumentId.value && tableInput.value) {
    const record = tableInput.value.find((i) => {
      if (i.id === fileVersionDataDocumentId.value) {
        return i;
      }
    });

    if (record && record.file_version_data) {
      returnValue = JSON.parse(record.file_version_data);
    }
  }

  return returnValue;
});

const displayHiddenColumns = ref(false);

const storedZipFileData = ref({});

async function getZipFileData() {
  const response = await ZipFileDataService.getZipFileData();

  response.data.forEach((val) => {
    storedZipFileData.value[val.uid] = JSON.parse(val.data);
  })
}

async function saveZipFileData(documentId, file) {
  if (file.size < 1000000000) {
    let dictionary = {};

    dictionary[documentId] = { files: [], folders: {} };

    let blobDictionary = await readZipFile(file);

    if (blobDictionary) {
      const blobDictionaryKeys = Object.keys(blobDictionary);

      if (blobDictionaryKeys && blobDictionaryKeys.length > 0) {
        blobDictionaryKeys.forEach((zipStructure) => {
          let blobArr = blobDictionary[zipStructure];

          let folderStructure = zipStructure.indexOf("/") >= 0 ? `${zipStructure.substring(zipStructure.indexOf("/") + 1)}` : "";

          blobArr.forEach((blobObj) => {
            addFileToDictionary(documentId, folderStructure, blobObj.fileName, dictionary);
          })
        })

        storedZipFileData.value[documentId] = convertDictionaryToNodes(documentId, dictionary[documentId], 0);

        const formData = new FormData();

        formData.append("data", JSON.stringify(storedZipFileData.value[documentId]));

        ZipFileDataService.saveZipFileData(documentId, formData);
      }
    }
  }
}

// returns a dictionary of blob array from the zip file
async function readZipFile(file) {
  let blobDictionary = {};

  const newTreeKey = await APIKeyService.generateZipIdentifier(file.name);

  const fileAsArrayBuffer = await new Blob([file]).arrayBuffer();
  const regBuffer = await Buffer.from( new Uint8Array(fileAsArrayBuffer))

  return new Promise((resolve, reject) => {
      yauzl.fromBuffer(regBuffer, {lazyEntries: true}, function(err, zipfile) {
        if (zipfile) {
          zipfile.readEntry();
          zipfile.on("entry", async (entry) => {
            // skips directory; a directory is considered an entry
            if (/\/$/.test(entry.fileName)) {
              return zipfile.readEntry();
            }

            zipfile.openReadStream(entry, {decompress: entry.isCompressed() ? true : null}, function (err, readStream) {
              if (err) {
                zipfile.close();
                return reject("Failed to read file in artifact");
              }

              // collect data into buffer
              let buffer = null;
              readStream.on('data', function(d) {
                if (!buffer) {
                  buffer = d;
                } else {
                  buffer = Buffer.concat([buffer, d]);
                }
              });

              // file data collection completed
              readStream.on('end', async function () {
                let fileName = entry.fileName.split("/");
                fileName = fileName[fileName.length - 1];
                let mimeType = "";
                // Gets the MIME type from a buffer;
                const fileType = await fileTypeFromBuffer(buffer);

                if (fileType) {
                  mimeType = fileType.mime;
                } else if (!entry.fileName.includes("__MACOSX")) {
                  // Checks for corrupted PDF;
                  // Condition: If 'fileType' is undefined and has '.pdf' extension
                  mimeType = fileName.endsWith(".pdf") ? "" : "text/*";
                }

                if (mimeType) {
                  let zipStructure = `${newTreeKey}/${entry.fileName.replace(fileName, '')}`;
                  zipStructure = zipStructure.slice(0, -1); // remove extra "/" at the end

                  if (blobDictionary[zipStructure] == undefined) {
                    blobDictionary[zipStructure] = [];
                  }

                  let blobArr = blobDictionary[zipStructure];

                  const blobValue = new Blob([buffer], { type: mimeType });
                  let objElement = {
                    "blob": blobValue,
                    "fileName": fileName,
                    "mimeType": mimeType,
                  };
                  blobArr.push(objElement);
                }
                // continue to next entry
                zipfile.readEntry();
              });

              // fail on error
              readStream.on('error', function (err) {
                zipfile.close();
                return reject("Failed to extract file from artifact");
              });
            });
          });
          // end of entries
          zipfile.on("end", () => {
            resolve(blobDictionary);
          });
        } else {
          resolve(blobDictionary);
        }
      })
  })
}

function addFileToDictionary(documentId, folderStructure, filename, dictionary) {
  let folder = dictionary[documentId];

  if (folderStructure) {
    const folderStructureArray = folderStructure.split("/");

    for (let i = 0; i < folderStructureArray.length; i++) {
      let folderName = folderStructureArray[i];

      if (folder.folders[folderName] == undefined) {
        folder.folders[folderName] = { files: [], folders: {} };
      }

      folder = folder.folders[folderName];
    }
  }

  folder.files.push(filename);
}

function convertDictionaryToNodes(documentId, storedFolder, level) {
  let returnValue = [];

  const folders = Object.keys(storedFolder.folders).sort();

  folders.forEach((folder) => {
    let nodeKey = `${folder}:${level}:${documentId}`;
    let children = convertDictionaryToNodes(documentId, storedFolder.folders[folder], level + 1);
    returnValue.push({ label: folder, icon: 'folder', nodeKey: nodeKey, children: children });
  });

  const filenames = storedFolder.files.sort();

  filenames.forEach((filename) => {
    let fileNodeKey = `${filename}:${level}:${documentId}`;

    returnValue.push({
      label: filename,
      nodeKey: fileNodeKey,
      icon: 'file_present'
    });
  });

  return returnValue;
}

async function deleteZipFileData(documentId) {
  if (storedZipFileData.value[documentId] !== undefined) {
    delete storedZipFileData.value[documentId];
    ZipFileDataService.deleteZipFileData(documentId);
  }
}

export default {
  //variable properties
  querySearchParameters,
  querySearchType,
  documentCategoryOptions,
  fileTypeOptions,
  schoolOptions,
  actionCategoryOptions,
  islandOptions,
  serviceContractTypeOptions,
  companyNameOptions,
  indexCounts,
  loadingQuerySearch,
  tableInput,
  searchCanceled,
  searchError,
  currentUserData,
  currentUserGroup,
  rowData,
  firestoreTableInput,
  displayCancelBtn,
  loadingInitialSearchResults,
  searchSubmitted,
  selectedSearchScopeOptions,
  selectedSearchScopeOptionsLength,
  nonDeleteList,
  nonEditList,
  nonUploadList,
  storedFileLatest,
  currentFileVersionData,
  displayHiddenColumns,
  storedZipFileData,

  //functions
  getScopeFields,
  filterDocumentCategory,
  setFileTypeOptions,
  filterFileType,
  filterSchool,
  filterActionCategory,
  filterIsland,
  filterServiceContractType,
  filterCompanyName,
  filterOptions,
  filterObjectOptions,
  getIndexCounts,
  cancelSearch,
  setCurrentUserData,
  getUserGroups,
  addFileInfoDocumentName,
  getSchoolNameArray,
  retrieveFirestoreIndex,
  displayMetadata,
  checkLoadingQuerySearch,
  addSelectedSearchScopeOption,
  submitSearch,
  checkDocumentUpdate,
  submitMayanServiceIndexSearch,
  submitMayanServiceSingularSearch,
  mayanServiceSingularSearch,
  deleteFromTableInput,
  getFastifyFilename,
  createEmptyDocument,
  getHeaderButtonColor,
  isValidDate,
  checkValidDateArray,
  sortArrayOfObjects,
  checkScopeEdit,
  checkScopeUpload,
  openURLToNewTab,
  replaceHTMLReservedCharacters,
  updateStoredFileLatest,
  getZipFileData,
  saveZipFileData,
  readZipFile,
  deleteZipFileData
};